import React from 'react';

import classnames from 'classnames';

import Validated from 'components/util/Validated';

import RoleSchemas from 'schemas/roles_schemas';

import { Form } from 'common/components';

import RolePermissionsForm from 'roles/components/RolePermissionsForm';

const RolesForm = ({
  id = '',
  companyId = '',
  errors = {},
  isLoading = false,
  isLoadingPermissions = false,
  isSubmitted = false,
  handleSubmit = () => {},
  handleValueChange = () => {},
  handleCheckPermission = () => {},
  handleClickPermissionRow = () => {},
  handleCheckSection = () => {},
  permissions = { bySection: {}, allSections: [] },
  t = (k) => k,
  values = {},
}) => {
  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      <div className="row mt-3 align-items-center">
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            autoFocus={true}
            error={(isSubmitted && errors.name) || {}}
            name={'name'}
            label={t('roles.fields.name')}
            placeholder={t('roles.fields.name')}
            handleChange={handleValueChange}
            t={t}
            value={values.name}
            disabled={!!id}
          />
        </div>
      </div>

      <RolePermissionsForm
        t={t}
        bySection={permissions.bySection}
        allSections={permissions.allSections}
        handleCheckPermission={handleCheckPermission}
        handleClickPermissionRow={handleClickPermissionRow}
        handleCheckSection={handleCheckSection}
        values={values.permissions}
      />

      <div className="col-md-12">
        <Form.Button
          text={t('actions.save')}
          isLoading={isLoading}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={`/companies/${companyId}/roles`}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isLoading,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated(RoleSchemas.edit)(RolesForm);



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/components/RoleForm.js